import { PlaylistAdd } from "@mui/icons-material";
import { Button } from "@mui/material";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";

import { isMaxItemsReached } from "@ryde/shared";

import { TimeListItemEdit } from "./time-list-item.edit";
import { emptyTimeItem, ITimeListItemForm } from "./time-list-item.models";

export const TimeListItemAdd: FC<ITimeListItemForm> = ({
  index,
  setValueOuter,
  fieldName,
  formAttributes,
}) => {
  const { t } = useTranslation();
  const [isAddNewOpened, setAddNewOpenedState] = useState(false);
  const hideAppendButton = isMaxItemsReached(
    formAttributes?.maxItemsToAdd,
    index || 0,
  );

  return (
    <>
      {isAddNewOpened && (
        <TimeListItemEdit
          fieldName={`${fieldName}[${index || 0}]`}
          setValueOuter={setValueOuter}
          value={emptyTimeItem}
          index={index}
          formAttributes={formAttributes}
          onCancelOuter={() => {
            setAddNewOpenedState(false);
          }}
        />
      )}
      {!isAddNewOpened && !hideAppendButton && (
        <Button
          type="button"
          size="medium"
          className="add_button"
          startIcon={<PlaylistAdd />}
          onClick={() => setAddNewOpenedState(true)}
        >
          {t("general.APPEND")}
        </Button>
      )}
    </>
  );
};
